( (app, ng)=> {

	app.component("birthdays",
		{
			templateUrl: "/App/Dashboard/Tiles/Birthdays/birthdays.template.html",
			controller: totalAumController,
			bindings: {
				currentUser: "<"
			}
		});

	function totalAumController(moment, reportApi, $timeout) {
		const $ctrl = this;

		ng.extend($ctrl, {
			ui: {
				loading: false,
				exporting: false
			},
			birthdayContacts: [],
			params: {
				"Type": "Client",
				"Properties": {
					"Parameters": [
						"FirstName",
						"LastName",
						"DateOfBirth",
						"ClientId",
						"EmailAddress",
						"StreetAddress1",
						"StreetAddress2",
						"City",
						"StateCode",
						"PostalCode",
						"PhoneNumber"
					],
					"Condition": {
						"operation": "and",
						"parameters": [
							{
								"type": "DateTime",
								"operation": "andmonth",
								"parameters": [
									{
										"operation": ">=month",
										"type": "DateTime",
										"parameters": [
											{
												"parameter": "DateOfBirth"
											},
											{
												"constant": new Date().getMonth() + 1
											}
										]
									},
									{
										"operation": "<=month",
										"type": "DateTime",
										"parameters": [
											{
												"parameter": "DateOfBirth"
											},
											{
												"constant": new Date().getMonth() + 2
											}
										]
									}
								]
							}
						]
					},
					"Type": "Client"
				}
			},
			searchText: '',
			today: moment().format("M/D/YYYY")
		});

		const getReportResults = (nextPageToken) => {
			$ctrl.ui.loading = true;

			return reportApi.runReport($ctrl.params, nextPageToken)
				.then(function (results) {
					if (!results.Rows.NextPage) return results;
					return getReportResults(results.Rows.NextPage)
						.then(function (response) {
							results.Rows.Entries = _.concat(results.Rows.Entries, response.Rows.Entries);
							return results;
						});
				})
				.finally(() => {
					$ctrl.ui.loading = false;
				});
		};

		const getReportFile = (exportedReportId) => {
			return reportApi.getExportedReport(exportedReportId)
				.then(function (response) {
					if (response === null)
						return getReportFile(exportedReportId);
					else return response;
				});
		};

		$ctrl.exportBirthdays = () => {
			$ctrl.ui.exporting = true;
			$ctrl.birthdayReport = {
				CustomProperties: null,
				IsPublic: false,
				Owner: $ctrl.currentUser,
				OwnerId: $ctrl.currentUser.Id,
				Properties: $ctrl.params.Properties,
				Type: $ctrl.params.Type
			};
			//TODO: better way of dropping clientId from report?
			$ctrl.birthdayReport.Properties.Parameters.splice(3, 1);

			reportApi.export($ctrl.birthdayReport)
				.then(function (response) {
					getReportFile(response.Id)
						.then(function (file) {
							var f = document.createElement("a");
							document.body.appendChild(f);
							f.style = "display:none";

							var fUrl = window.URL.createObjectURL(file);
							f.href = fUrl;
							f.download = "birthdayReport_" + $ctrl.today + ".xlsx";
							f.click();

							$timeout(function () {
								document.body.removeChild(f);
								window.URL.revokeObjectURL(fUrl);
							}, 100);
						});
				})
				.catch((error) => {
					console.log("Error exporting birthday data", !!error.message
						? error.message
						: error.data
					);
				})
				.finally(() => $ctrl.ui.exporting = false);
		};

		$ctrl.contactFilter = (contact) => {
			if (!$ctrl.searchText) return true;
			$ctrl.searchText = !!$ctrl.searchText ? $ctrl.searchText.toLowerCase() : '';
			if (contact.Client.toLowerCase().indexOf($ctrl.searchText) !== -1) return true;
			if (contact.DateOfBirth.indexOf($ctrl.searchText) !== -1) return true;
			return false;
		};

		$ctrl.$onInit = () => {
			getReportResults()
				.then(function (response) {
					var td = new Date();
					var fd = new Date();
					fd.setDate(fd.getDate() + 30);

					ng.forEach(response.Rows.Entries, function (c) {

						var birthdayContact = {};

						if (moment(c[2]).format("MM/DD") > moment(td).format("MM/DD") && moment(c[2]).format("MM/DD") < moment(fd).format("MM/DD")) {
							birthdayContact.Client = c[0] + " " + c[1];
							birthdayContact.DateOfBirth = moment(c[2]).format("M/D/YYYY");
							birthdayContact.ClientId = c[3];
							$ctrl.birthdayContacts.push(birthdayContact);
						}
					});
				})
				.catch((error) => {
					console.log("Error getting birthday report", !!error.message
						? error.message
						: error.data
					);
				})
				.finally(() => $ctrl.ui.loading = false);
		};
	}

})(window.app, window.angular); //jshint ignore:line